export default __webpack_public_path__ + "static/media/whiteLogo.c074b63a.png";